import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // 1. Track Facebook Pixel PageView on route change
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }

    // 2. Track Google Analytics PageView on route change
    if (window.gtag) {
      window.gtag('config', 'G-7SPYDXBEQM', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
};

export default RouteTracker;
